import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress, configure_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as Publish } from "../../../assets/svg/modules/new-publish.svg";

const SMPOverview = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                smp_overview: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    }, []);
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <Publish className="icon_content fill_svg fill_stroke_svg" />

                        <span className="content_title">Publishing Overview</span>
                    </div>
                    <div className="text_content">
                        <p>{`Social Media Publishing module helps you create and publish content to multiple social platforms from a single unified content creation and scheduling platform.`}</p>
                        <p>
                            {`While you are at it, see we what’s trending right now and get inspired.
`}
                        </p>

                        <p>There are list views and calendar views and a full publishing workflow. Publish your posts now or at any time in the future.</p>
                        <p>Need posts to be approved before they are posted? No problem, we have you covered.</p>
                        <p>
                            {` Need to find out how your posted content is performing? That’s available too. We can’t wait to see the magic you will create!`}
                        </p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    {/* <Link to="/profile">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link> */}
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/bjqgy4ucabw"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMPOverview;
